export class ApiError extends Error {
  readonly status: number
  readonly requestId: string
  /** Server error code/message from the JSON body, when there is one. */
  readonly code?: string

  constructor(status: number, message: string, requestId: string, code?: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.requestId = requestId
    this.code = code
  }
}

/** 403 from RequireCapability: the user lacks `requiredCapability` in this condominium. */
export class ForbiddenError extends ApiError {
  readonly requiredCapability?: string

  constructor(message: string, requestId: string, requiredCapability?: string) {
    super(403, message, requestId)
    this.name = 'ForbiddenError'
    this.requiredCapability = requiredCapability
  }
}
